import AuthLayout from '../../../components/shared/AuthLayout';
import ForgetPasswordForm from '../../../components/auth/ForgetPasswordForm';
import { Link } from '@mui/material';

const ForgotPasswordPage = () => {
  const sideImageUrl = "https://images.unsplash.com/photo-1579546929662-711aa81148cf?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80";

  return (
    <AuthLayout
      sideImageUrl={sideImageUrl}
      FormComponent={ForgetPasswordForm}
      pageTitle="Reset Password"
      pageDescription="Enter your email address and we'll send you a secure link to reset your password"
      sideTitle="Forgot Your Password?"
      sideSubtitle="Don't worry! We'll help you get back into your account securely and quickly."
      additionalLink={
        <Link 
          href="/fmr/sign-in" 
          sx={{ 
            color: '#00ff88', 
            fontWeight: 600, 
            '&:hover': { 
              textDecoration: 'underline',
              color: '#66ffb3'
            } 
          }}
        >
          ← Back to Sign In
        </Link>
      }
    />
  );
};

export default ForgotPasswordPage;